import Vue from 'vue';
import App from './App.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import StarRating from 'vue-star-rating';
import Croppa from 'vue-croppa';
import InfiniteLoading from 'vue-infinite-loading';
import Intersect from 'vue-intersect';
import VueImg from 'v-img';
import Cookbookselector from './components/cookbookselector.vue';
import Recipecard from './components/recipecard.vue';

import { BootstrapVue } from 'bootstrap-vue';
import './scss/bootstrap.scss';
import './scss/vue.scss';

import 'vue-search-select/dist/VueSearchSelect.css';
import { ModelListSelect } from 'vue-search-select';

import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

import Draggable from 'vuedraggable';

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';

import vueFilePond from 'vue-filepond';
// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginExifOrientation
  from 'filepond-plugin-image-exif-orientation';
import FilePondPluginResize from 'filepond-plugin-image-resize';
import FilePondPluginTransform from 'filepond-plugin-image-transform';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.min.css';
// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginResize,
  FilePondPluginTransform,
  FilePondPluginFileEncode,
  FilePondPluginFilePoster,
);

import { VueSvgGauge } from 'vue-svg-gauge';

var ba_defaults = {
  BCalendar: {
    labelCurrentMonth: 'Aktueller Monat',
    labelNextMonth: 'Nächster Monat',
    labelNextYear: 'Nächstes Jahr',
    labelPrevMonth: 'Vorheriger Monat',
    labelPrevYear: 'Vorheriges Jahr',
    labelNoDateSelected: 'Kein Datum gewählt',
    labelHelp: '',
  },
};

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue, ba_defaults);
Vue.use(Croppa);
Vue.use(InfiniteLoading);
Vue.use(Intersect);
Vue.use(VueImg);
Vue.use(ModelListSelect);
Vue.use(VueSlickCarousel);
Vue.use(VueSvgGauge);
Vue.use(Draggable);

// global angelegt, sind dadurch in den Drupal Vue Apps direkt erreichbar
// und müssen nicht local registriert werden
Vue.component('recipecard', Recipecard);
Vue.component('cookbookselector', Cookbookselector);

import {
  setDefaultOptions,
  formatDistance,
  subDays,
  format,
  isEqual,
  isSameDay,
  isBefore,
  add,
  sub,
  getUnixTime,
  isWithinInterval,
} from 'date-fns';
import { de } from 'date-fns/locale';

/* Globales date-fns Object */
Vue.prototype.$datedns = {};
Vue.prototype.$datedns.formatDistance = formatDistance;
Vue.prototype.$datedns.subDays = subDays;
Vue.prototype.$datedns.format = format;
Vue.prototype.$datedns.isEqual = isEqual;
Vue.prototype.$datedns.isSameDay = isSameDay;
Vue.prototype.$datedns.isBefore = isBefore;
Vue.prototype.$datedns.add = add;
Vue.prototype.$datedns.sub = sub;
Vue.prototype.$datedns.getUnixTime = getUnixTime;
Vue.prototype.$datedns.isWithinInterval = isWithinInterval;
Vue.prototype.$datedns.de = de;
Vue.prototype.$datedns.setDefaultOptions = setDefaultOptions;
Vue.prototype.$datedns.setDefaultOptions({ locale: de });

if (process.env.NODE_ENV == 'development') {
  Vue.config.devtools = true;
  Vue.config.silent = false;
  Vue.config.productionTip = true;
} else {
  Vue.config.productionTip = false;
  Vue.config.devtools = false;
  Vue.config.silent = true;
}

Drupal.Vue = Drupal.Vue || {};

Drupal.Vue = {
  apps: {},
  instances: {},
  vue: null,
  vue_instance: null,
  components: {},
  mixins: {},

  registerComponent: function (component) {
    var self = this;
    if (component.component) {
      self.vue.component(component.id, component.component(self.vue, component.id, self.components));
    }
  },

  registerApp: function (appinfo) {
    var self = this;
    self.apps[appinfo.id] = appinfo;
    if (appinfo.type === 'app') {
      if (appinfo.app) {
        if (appinfo.delay !== undefined) {
          self.apps[appinfo.id].instance = null;
          self.apps[appinfo.id].appinfo = appinfo;
          if (appinfo.delay > 0) {
            setTimeout(function (vueapp, vuebase) {
              vuebase.apps[appinfo.id].instance = vueapp.app(vuebase.vue, vueapp.id, vuebase.components, vueapp.settings ? vueapp.settings : {});
            }, appinfo.delay, appinfo, self);
          }
        } else {
          self.apps[appinfo.id].appinfo = appinfo;
          self.apps[appinfo.id].instance = appinfo.app(self.vue, appinfo.id, self.components, self.settings ? self.settings : {});
        }
      }
    }
  },
  startApps: function () { },
  getApp: function (appid) {
    var self = this;
    if (self.apps[appid]) {
      return self.apps[appid].instance;
    } else {
      return null;
    }
  },
  startApp: function (appid) {
    var self = this;
    if (self.apps[appid]) {
      if (!self.apps[appid].instance) {
        var appinfo = self.apps[appid].appinfo;
        self.apps[appinfo.id].instance = appinfo.app(self.vue, appinfo.id, self.components);
      }
      return self.apps[appid].instance;
    } else {
      return null;
    }
  },
  sendEvent: function (event, parameter1, parameter2, parameter3) {
    this.vue_instance.$eventbus.$emit(event, parameter1, parameter2, parameter3);
  },
  registerEvent: function (event, fn) {
    this.vue_instance.$eventbus.$on(event, fn);
  },
  unregisterEvent: function (event, fn) {
    this.vue_instance.$eventbus.$off(event, fn);
  },
  showMessage: function (message, title = '', type = 'primary', options = {}) {
    this.vue_instance.$children[0].message(message, title, type, options);
  },
  confirmDialog: function (message, title, options = {}, success = null, cancel = null) {
    this.vue_instance.$children[0].$refs.confirm.show(message, title, options, success, cancel);
  },
  alertDialog: function (message, title, options = {}) {
    this.vue_instance.$children[0].$refs.alert.show(message, title, options);
  },
  promptDialog: function (message, title, options = {}, success = null, cancel = null) {
    this.vue_instance.$children[0].$refs.prompt.show(message, title, options, success, cancel);
  },
};

Drupal.Vue.vue = Vue;
Drupal.Vue.components = {
  'VuePerfectScrollbar': VuePerfectScrollbar,
  'StarRating': StarRating,
  'Croppa': Croppa,
  'Intersect': Intersect,
  'ModelListSelect': ModelListSelect,
  'VueSlickCarousel': VueSlickCarousel,
  'VueSvgGauge': VueSvgGauge,
  'Draggable': Draggable,
  'VueSlider': VueSlider,
  'FilePond': FilePond,
};
Drupal.Vue.mixins = {};

/**
 * Main Window Resize Event Handler. sendet einen Vue Event auf den Bus
 */
jQuery(window).resize(function () {
  /* Resize Event an alle über den globalen Vue Bus senden, dieser wurde im low_vue Modul angelegt */
  Drupal.Vue.sendEvent('resize-window');
});

Drupal.Vue.vue_instance = new Vue({
  render: h => h(App),
}).$mount('#vuebase');

/* Globaler Eventbus zwischen den Vue Instanzen (nur Vue 2.x)*/
Object.defineProperties(Vue.prototype, {
  $eventbus: {
    get: function () {
      return Drupal.Vue.vue_instance;
    },
  },
});

(function ($, Drupal) {
  $(document).ready(function () {
    Drupal.Vue.startApps();
  });
})(jQuery, Drupal);






